export const kFormatter = (num) => {
    // const regNumber = /^\d+$/;
    // const regDecimalNumber = /^\d+\.\d{0,2}$/;
    // if(regNumber.test(num) || regDecimalNumber.test(num)) {
    const numComma = `${num}`.replace(/,/g, '')
    if(numComma > 999 && numComma < 1000000){
        return (numComma/1000).toFixed(1) + 'K' 
    }else if(numComma > 1000000){
        return (numComma/1000000).toFixed(1) + 'M'
    }else if(numComma < 900){
        return numComma
    }
}